import { render, staticRenderFns } from "./InfoDrawer.vue?vue&type=template&id=5952a05e&scoped=true&"
import script from "./InfoDrawer.vue?vue&type=script&lang=js&"
export * from "./InfoDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InfoDrawer.vue?vue&type=style&index=0&id=5952a05e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952a05e",
  null
  
)

export default component.exports